<template>
  <div class="row mx-0 white_bg">
    <div class="col-12 py-5">
      <div class="container">
        <div class="row justify-content-center">
          <div class="col-12 text-center fs-1 mb-3">
            Privacy Policy
          </div>
          <div class="col-12">
           <p>When accessing our Website, www.simplest.co.za will learn certain information about you during your visit. How we will handle information we learn about you depends upon what you do when visiting our site.</p>
<p>If you visit our site to read or download information on our pages, we collect and store only the following information about you:</p>
<p>1. The name of the domain from which you access the Internet<br />
2. The date and time you access our site<br />
3. The Internet address of the website you used to link directly to our site.<br />
4. Details provided by users with their consent, including:</p>
<ul>
<li> Name</li>
<li> Contact details</li>
<li> Payment details</li>
</ul>
<p>If you identify yourself by sending us an e-mail containing personal information, then the information collected will be solely used to respond to your message.</p>
<p>The information collected is for statistical purposes. www.simplest.co.za may use software programs to create summary statistics, which are used for such purposes as assessing the number of visitors to the different sections of our site, what information is of most and least interest, determining technical design specifications, and identifying system performance or problem areas.</p>
<p>For site security purposes and to ensure that this service remains available to all users, www.simplest.co.za uses software programs to monitor network traffic to identify unauthorized attempts to upload or change information, or otherwise cause damage.</p>
<p>www.simplest.co.za will not obtain personally-identifying information about you when you visit our site, unless you choose to provide such information to us, nor will such information be sold or otherwise transferred to unaffiliated third parties without the approval of the user at the time of collection.</p>
<p>Generated by: <a title="Northern Virginia Business Attorneys and Lawyers" href="http://www.generalcounsellaw.com" target="_blank">General Counsel, PC</a> and <a title="Small Business Attorneys and Lawyers" href="http://www.LegalRiver.com" target="_blank">Legal River</a>&#8216;s <a title="Privacy Policy Generator" href="http://privacy-policy-generator.legalriver.com" target="_blank">Privacy Policy Generator</a></p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Success',
  mounted () {
    window.scrollTo(0, 0)
  }
}
</script>
<style scoped>

</style>
